import {
  getImageFromUrl,
  getFallbackImageFromUrl,
  getTouchPointImage,
  getTouchPointImageRegular,
  getTouchPointThumb,
  getTouchPointThumbFallback,
} from "./imageService";
import get from "lodash/get";
import noProfile from "../static/images/no-profile.png";
import dayjs from "dayjs";
import { toast } from "react-toastify";

import CommentedTPInfoIcon from "../components/svgs/СommentedTPInfoIcon";
import EditedTPInfoIcon from "../components/svgs/EditedTPInfoIcon";
import FirstTPInfoIcon from "../components/svgs/FirstTPInfoIcon";
import LikedTPInfoIcon from "../components/svgs/LikedTPInfoIcon";
import NewTaskInfoIcon from "../components/svgs/NewTaskInfoIcon";
import NewTPInfoIcon from "../components/svgs/NewTPInfoIcon";
import NewCardCreated from "../components/svgs/NewCardCreated";
import MilestoneCreated from "../components/svgs/MilestoneCreated";
import UpdatedBrandPageInfoIcon from "../components/svgs/UpdatedBrandPageInfoIcon";
import NewQuizInfoIcon from "../components/svgs/NewQuizInfoIcon";
import NewMentionInfoIcon from "../components/svgs/NewMentionInfoIcon";
import LevelUpIcon from "../components/svgs/LevelUpIcon";
import ChallengeReachedIcon from "../components/svgs/ChallengeReachedIcon";
import NewSurveyIcon from "../components/svgs/NewSurveyIcon";

export const notificationsTemplates = {
  TPCreated: "TPCreated",
  TPCommentedOwner: "TPCommentedOwner",
  TPCommentedOther: "TPCommentedOther",
  TPEditedOwner: "TPEditedOwner",
  TPLiked: "TPLiked",
  taskUpdated: "taskUpdated",
  ourBrandUpdated: "ourBrandUpdated",
  firstTPCreated: "firstTPCreated",
  milestoneCreated: "milestoneCreated",
  newCardCreated: "newCardCreated",
  userMentionedTP: "userMentionedTP",
  userMentionedCard: "userMentionedCard",
  quizCreated: "quizCreated",
  rankingLevel: "rankingLevel",
  challengeFinished: "challengeFinished",
  surveyStarted: "surveyStarted",
  surveyCreated: "surveyCreated",
  tpSurveyStarted: "tpSurveyStarted",
};

export const getLogoOptions = (notification, viewProfile, setReviewed) => {
  let [image, fallbackImage, viewDetails] = [];
  switch (notification.template) {
    case notificationsTemplates.TPCommentedOwner:
    case notificationsTemplates.TPCommentedOther:
    case notificationsTemplates.rankingLevel:
      image = getImageFromUrl(get(notification.triggerUser, "photoURL"));
      fallbackImage = getFallbackImageFromUrl(get(notification.triggerUser, "photoURL"), noProfile);
      viewDetails = e => {
        e.stopPropagation();
        setReviewed(notification, true);
        viewProfile(notification.triggerUser);
      };
      break;
    case notificationsTemplates.TPLiked:
    case notificationsTemplates.firstTPCreated:
      image = getImageFromUrl(get(notification.triggerUser, "photoURL"));
      fallbackImage = getFallbackImageFromUrl(get(notification.triggerUser, "photoURL"), noProfile);
      break;
    case notificationsTemplates.TPCreated:
    case notificationsTemplates.TPEditedOwner:
    case notificationsTemplates.milestoneCreated:
    case notificationsTemplates.newCardCreated:
    case notificationsTemplates.userMentionedTP:
    case notificationsTemplates.userMentionedCard:
    case notificationsTemplates.surveyStarted:
      image = getTouchPointThumb(notification.effectedTouchPoint);
      fallbackImage = getTouchPointThumbFallback(notification.effectedTouchPoint);
      break;
    default:
      image = getTouchPointImage(notification.client);
      fallbackImage = getTouchPointImageRegular(notification.client);
      break;
  }
  return [image, fallbackImage, viewDetails];
};

export const getPrimaryAction = (notification, viewProfile, viewTouchPoint, viewPage) => {
  let viewDetails;
  switch (notification.template) {
    case notificationsTemplates.TPLiked:
    case notificationsTemplates.firstTPCreated:
      viewDetails = () => {
        viewProfile(notification.triggerUser);
      };
      break;
    case notificationsTemplates.TPCreated:
    case notificationsTemplates.TPEditedOwner:
    case notificationsTemplates.milestoneCreated:
    case notificationsTemplates.userMentionedTP:
    case notificationsTemplates.surveyStarted:
    case notificationsTemplates.tpSurveyStarted:
      viewDetails = () => {
        viewTouchPoint(get(notification, "effectedTouchPoint._id", ""));
      };
      break;
    case notificationsTemplates.TPCommentedOwner:
    case notificationsTemplates.TPCommentedOther:
      viewDetails = () => {
        viewTouchPoint(get(notification, "effectedTouchPoint._id", ""), notification.commentCreated);
      };
      break;
    case notificationsTemplates.newCardCreated:
    case notificationsTemplates.userMentionedCard:
      viewDetails = () => {
        viewPage("orga-board");
      };
      break;
    case notificationsTemplates.quizCreated:
      viewDetails = () => {
        viewPage("quiz");
      };
      break;
    case notificationsTemplates.surveyCreated:
      viewDetails = () => {
        viewPage("survey");
      };
      break;
    case notificationsTemplates.rankingLevel:
      viewDetails = () => {
        viewPage("profile");
      };
      break;
    case notificationsTemplates.challengeFinished:
      viewDetails = () => {
        viewPage("tasks");
      };
      break;
    default:
      let pageUrl =
        notification.template === notificationsTemplates.ourBrandUpdated
          ? "our-brand"
          : notification.template === notificationsTemplates.surveyCreated
            ? "survey"
            : notification.template === notificationsTemplates.rankingLevel
              ? "profile"
              : notification.template === notificationsTemplates.quizCreated
                ? "quiz"
                : "tasks";
      viewDetails = () => {
        viewPage(pageUrl);
      };
      break;
  }
  return viewDetails;
};

export const getTimeAgo = (notification, t) => {
  const date = new Date(notification.createdAt);
  const minutes = Math.floor((new Date() - date) / 60000);
  const hours = Math.ceil(minutes / 60);
  switch (true) {
    case minutes < 2:
      return t("notifications.notificationJustNow");
    case minutes < 60:
      return t("notifications.notificationMinutesAgo", { minutes: minutes });
    case minutes < 1440:
      return t("notifications.notificationHoursAgo", { hours: hours });
    default:
      return dayjs(notification.createdAt).format("DD.MM.YYYY");
  }
};

export const getInfoIconImage = (notification, color, color2) => {
  switch (notification.template) {
    case notificationsTemplates.TPCommentedOwner:
    case notificationsTemplates.TPCommentedOther:
      return <CommentedTPInfoIcon color={color} color2={color2} />;
    case notificationsTemplates.userMentionedTP:
    case notificationsTemplates.userMentionedCard:
      return <NewMentionInfoIcon color={color} color2={color2} />;
    case notificationsTemplates.TPEditedOwner:
      return <EditedTPInfoIcon color={color} color2={color2} />;
    case notificationsTemplates.TPCreated:
      return <NewTPInfoIcon color={color} color2={color2} />;
    case notificationsTemplates.TPLiked:
      return <LikedTPInfoIcon color={color} color2={color2} />;
    case notificationsTemplates.ourBrandUpdated:
      return <UpdatedBrandPageInfoIcon color={color} color2={color2} />;
    case notificationsTemplates.taskUpdated:
      return <NewTaskInfoIcon color={color} color2={color2} />;
    case notificationsTemplates.milestoneCreated:
      return <MilestoneCreated color={color} color2={color2} />;
    case notificationsTemplates.newCardCreated:
      return <NewCardCreated color={color} color2={color2} />;
    case notificationsTemplates.quizCreated:
      return <NewQuizInfoIcon color={color} color2={color2} />;
    case notificationsTemplates.rankingLevel:
      return <LevelUpIcon color={color} color2={color2} />;
    case notificationsTemplates.challengeFinished:
      return <ChallengeReachedIcon color={color} color2={color2} />;
    case notificationsTemplates.surveyStarted:
    case notificationsTemplates.tpSurveyStarted:
      return <NewSurveyIcon color={color} color2={color2} />;
    default:
      return <FirstTPInfoIcon color={color} color2={color2} />;
  }
};

export function notifySuccess(message) {
  toast.info(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}

export function notifyDataLoadFailed(message) {
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}

export function notifyFailed(message) {
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}
